import type { FC, ReactElement } from "react";
import { ButtonPlaceholderLoader } from "@similarweb/ui-components";

import {
    StyledButtonPlaceholderLoader,
    StyledComingSoonLabelWrapper,
    StyledCrmEnrichmentCard,
    StyledEnrichmentButtonWrapper,
    StyledEnrichmentContactAdminText,
    StyledEnrichmentDescription,
    StyledEnrichmentImageWrapper,
} from "./styles";
import { AssetsService } from "app/services/AssetsService";
import EnrichmentCardLoader from "../EnrichmentCardLoader/EnrichmentCardLoader";
import ComingSoonLabel from "../ComingSoonLabel/ComingSoonLabel";

type CrmEnrichmentCardProps = {
    isLoading?: boolean;
    imageUrl: string;
    description: string;
    videoUrl: string;
    isActionDisabled?: boolean;
    disabledActionText?: string;
    ctaButton: ReactElement;
    isCrmAvailable?: boolean;
};

const CrmEnrichmentCard: FC<CrmEnrichmentCardProps> = ({
    imageUrl,
    videoUrl,
    description,
    isActionDisabled,
    disabledActionText,
    isLoading,
    ctaButton,
    isCrmAvailable,
}) => {
    return (
        <StyledCrmEnrichmentCard>
            {!isCrmAvailable && !isLoading ? (
                <StyledComingSoonLabelWrapper>
                    <ComingSoonLabel
                        textKey={"common.coming.soon"}
                        iconName={"card-label"}
                    />
                </StyledComingSoonLabelWrapper>
            ) : null}
            <StyledEnrichmentImageWrapper isCrmAvailable={isCrmAvailable}>
                <img
                    width={119}
                    height={119}
                    alt="picture integration"
                    src={AssetsService.assetUrl(imageUrl)}
                />
            </StyledEnrichmentImageWrapper>
            {isLoading ? (
                <>
                    <EnrichmentCardLoader />
                    <StyledButtonPlaceholderLoader>
                        <ButtonPlaceholderLoader />
                    </StyledButtonPlaceholderLoader>
                </>
            ) : (
                <StyledEnrichmentDescription>{description}</StyledEnrichmentDescription>
            )}
            {!isLoading && !isActionDisabled && isCrmAvailable ? (
                <StyledEnrichmentButtonWrapper>{ctaButton}</StyledEnrichmentButtonWrapper>
            ) : null}
            {!isLoading && isActionDisabled && isCrmAvailable ? (
                <StyledEnrichmentContactAdminText>{disabledActionText}</StyledEnrichmentContactAdminText>
            ) : null}
        </StyledCrmEnrichmentCard>
    );
};

export default CrmEnrichmentCard;
